<template>
  <div :class="{ active: isOpened }" class="modal">
    <div v-if="isOpened">
      <login :close="closeModal" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Login from '@/components/Login.vue'

export default {
  components: { Login },

  computed: {
    isOpened() {
      return this.$store.getters.loginModal.open
    },
  },

  methods: {
    ...mapActions(['toggleLoginModal']),

    closeModal() {
      this.toggleLoginModal({ open: false })
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  @include background-modal-config;

  &.active {
    display: flex;
  }

  > div {
    @include modal-config(600);
    height: 420px;
  }
}
</style>
